const { isArray, forEach } = require('lodash');

class AnalyticsService {
    constructor($q, $log, $injector, $ocLazyLoad, sessionStorage, settings, events, bootstrapService, tagManagers, mapperTypes) {
        this.$q = $q;
        this.$log = $log;
        this.$injector = $injector;
        this.$ocLazyLoad = $ocLazyLoad;
        this.sessionStorage = sessionStorage;
        this.settings = settings;
        this.events = events;
        this.bootstrap = bootstrapService;
        this.tagManagers = tagManagers;
        this.mapperTypes = mapperTypes;
        this.init();
    }

    init() {
        this.tagManagerList = [];

        // check the switches.
        if (this.settings.analytics.useDtm) {
            this.tagManagerList.push(this.tagManagers.dtm.module);
        }
        if (this.settings.analytics.useGtm) {
            this.tagManagerList.push(this.tagManagers.gtm.module);
        }
        if (this.settings.analytics.useTealium) {
            this.tagManagerList.push(this.tagManagers.tealium.module);
        }

        // push user detail to update tealium analytics
        this.pushUserDetail('shouldTrackLoginEvent');
        this.pushUserDetail('shouldTrackSignupEvent');
    }

    loadMapperServices() {
        if (!this.mapperServicePromise) {
            this.mapperServicePromise = this.$ocLazyLoad.load(this.tagManagerList);

            this.mapperServicePromise.then(() => {
                this.tagManagerServices = [];

                // load the tag services.
                forEach(this.tagManagers, (tagManager) => {
                    if (this.$injector.has(tagManager.service)) {
                        this.tagManagerServices.push(this.$injector.get(tagManager.service));
                    }
                });
            });
        }

        return this.mapperServicePromise;
    }

    push({ data = {}, type = this.mapperTypes.default }) {
        this.loadMapperServices().then(() => {
            forEach(this.tagManagerServices, (tagManagerService) => {
                tagManagerService.push(data, tagManagerService.getMapper(type));
            });
        });
    }

    pushEvent(event) {
        this.push({ data: event, type: this.mapperTypes.common.event });
    }

    pushError(error) {
        this.push({ data: error, type: this.mapperTypes.common.error });
    }

    pushErrors(errors) {
        if (!errors) {
            this.$log.error('Truthy value is expected as the first argument of Analytics.pushErrors.');
            return;
        }

        if (!isArray(errors) || errors.length === 0) {
            this.$log.error('A populated array is expected as the first argument of Analytics.pushErrors.');
            return;
        }

        this.pushError(errors.join('|'));
    }

    pushUserDetail(sessionStorageName) {
        if (this.sessionStorage.getAndRemove(sessionStorageName)) {
            this.push({
                data: this.getUserDetail(),
                type: sessionStorageName === 'shouldTrackSignupEvent' ? this.mapperTypes.customEvent.account.userRegister : this.mapperTypes.customEvent.account.userLogin,
            });
        }
    }

    getUserDetail() {
        let shopperDetails, address, rewards = null;
        if (this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.ShopperDetails) &&
            this.bootstrap.isBootstrapped(this.bootstrap.bootstrapped.Trolley)) {
            shopperDetails = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.ShopperDetails) || {};
            address = shopperDetails.Address;
            shopperDetails.FirstName = 'REDACTED';
            shopperDetails.LastName = 'REDACTED';
            shopperDetails.DateOfBirthInput = 'REDACTED';
            shopperDetails.Email = 'REDACTED';
            shopperDetails.Phone = 'REDACTED';
            shopperDetails.SecondaryPhone = 'REDACTED';
            shopperDetails.Age = 'REDACTED';
            shopperDetails.CompanyName = 'REDACTED';
            shopperDetails.ABN = 'REDACTED';
            rewards = this.bootstrap.getBootstrappedData(this.bootstrap.bootstrapped.Trolley).WowRewardsSummary;
        }
        return {
            shopperDetails,
            address,
            rewards,
            trackingType: 'link',
        };
    }
}

AnalyticsService.$inject = ['$q', '$log', '$injector', '$ocLazyLoad', 'SessionStorageWrapper', 'Settings', 'AnalyticsEvents', 'BootstrapService', 'AnalyticsTagManagers', 'AnalyticsMappertypes'];

module.exports = AnalyticsService;



// WEBPACK FOOTER //
// ./src/analytics/analytics.service.js